import { Chip } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useI18n } from '../i18n';
import {
  profileStatusMessageKey,
  resolveProfileStatus,
} from '../profile/profileStatus';

interface ProfileStatusBadgeProps {
  kycLevel: number;
  firstName?: string | null;
}

export function ProfileStatusBadge({
  kycLevel,
  firstName,
}: ProfileStatusBadgeProps) {
  const { t } = useI18n();
  const status = resolveProfileStatus(kycLevel, firstName);
  const color =
    status === 'verified'
      ? 'success'
      : status === 'filled'
        ? 'warning'
        : 'default';

  return (
    <Chip
      component={RouterLink}
      to="/faq#profile-verification"
      clickable
      color={color}
      size="small"
      label={t(profileStatusMessageKey(status))}
      variant="outlined"
    />
  );
}
